/**
 * @fileoverview GET handler for the "/engagement/get_product_recommender_properties" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementGetProductRecommenderProperties } from "./constants";
import type {
  GetEngagementGetProductRecommenderPropertiesParams,
  GetEngagementGetProductRecommenderPropertiesResult,
} from "./types";
import { isGetEngagementGetProductRecommenderPropertiesResult } from "./validators";

export const getEngagementGetProductRecommenderProperties = reactQueryFetcherAdapter(
  engagementGetProductRecommenderProperties,
  (
    signal: AbortSignal,
    params: GetEngagementGetProductRecommenderPropertiesParams
  ): Promise<GetEngagementGetProductRecommenderPropertiesResult> => {
    return fetch("/engagement/get_product_recommender_properties", "GET", params, { signal });
  },
  isGetEngagementGetProductRecommenderPropertiesResult
);
